<div class="valuation-event-currencies-component" *ngIf="valuationPortfolioId > 0" [class.close]="shouldClose" [class.canClose]="canClose">
  <div *ngIf="!externalRatesDialogIsOpened && currenciesLoaded" class="valuation-event-currencies-component-container">
    <div *ngIf="canClose" class="closeButton" (click)="closeClicked()"></div>
    <div class="upper-text currency-management-description">
      <h2>FX Rates</h2>
      <p>
        {{ 'settingsDialog.currencyManagement.line1Description' | translate}}<br />
        {{ 'settingsDialog.currencyManagement.line2Description' | translate}}
      </p>
    </div>
    <div class="errorMessages" *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div>
    <div style="margin-left:20px; margin-right:20px; height: 470px; overflow-y: scroll;" *ngIf="!loading">
      <kendo-grid [data]="currencies"
                  style="width:100%">
        <kendo-grid-column field="pair" [title]="'valuationEventCurrencies.pair' | translate | uppercase" [width]="260">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div style="display: flex;" [ngClass]="{'redBorder': duplicateCurrenciesPairArray.includes(rowIndex) || duplicateCurrenciesOneRowArray.includes(rowIndex) || noProjectCurrencyArray.includes(rowIndex) || duplicateCurrenciesWithReversedOrderArray.includes(rowIndex)}">
              <kendo-dropdownlist class="curencies-dropdown" [(ngModel)]="dataItem.fromCurrencyId" [data]="currenciesReflist" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true" (ngModelChange)="onChange()"></kendo-dropdownlist>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column [width]="260">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div style="display: flex;" [ngClass]="{'redBorder': duplicateCurrenciesPairArray.includes(rowIndex) || duplicateCurrenciesOneRowArray.includes(rowIndex) || noProjectCurrencyArray.includes(rowIndex) || duplicateCurrenciesWithReversedOrderArray.includes(rowIndex)}">
              <kendo-dropdownlist class="curencies-dropdown" [(ngModel)]="dataItem.toCurrencyId" [data]="currenciesReflist" [textField]="'description'" [valueField]="'oid'" [valuePrimitive]="true" (ngModelChange)="onChange()"></kendo-dropdownlist>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="rate" [title]="'valuationEventCurrencies.rate' | translate | uppercase" [width]="220">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <div class="numeric-text-box-wrapper" [ngClass]="{'redBorder': emptyConversionRatesArray.includes(rowIndex)}">
              <kendo-numerictextbox [spinners]="false"
                                    format="n4"
                                    [(ngModel)]="dataItem.conversionRate"
                                    [value]="dataItem.conversionRate"
                                    [min]="0.0001"
                                    [autoCorrect]="true"
                                    (valueChange)="onChange()"
                                    class="numeric-text-box numeric-text-box-height-28 rates-numeric-box">
              </kendo-numerictextbox>
              <div class="download-external-rate">
                <img src="./assets/icons/download_black.png" title="Get rate from external source" alt="Get rate from external source" (click)="openExternalRateDialog(dataItem, rowIndex)" />
              </div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="clientRate" [title]="'valuationEventCurrencies.clientRate' | translate | uppercase" [width]="220">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
            <kendo-numerictextbox [style.width.px]="170"
                                  format="n4"
                                  [(ngModel)]="dataItem.clientConversionRate"
                                  [value]="dataItem.clientConversionRate"
                                  [spinners]="false"
                                  [min]="0.0001"
                                  [autoCorrect]="true"
                                  class="numeric-text-box numeric-text-box-height-28 rates-numeric-box">
            </kendo-numerictextbox>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column>
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <button class="valuation-delete-button" kendoButton (click)="deleteCurrencyRow(dataItem, rowIndex)">{{'valuationEventCurrencies.delete' | translate}}</button>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>

    <div class="buttons-container">
      <button kendoButton class="addMissingRates" (click)="addMissingRates()">{{'valuationEventCurrencies.addMissingRates' | translate}}</button>
      <button kendoButton class="addRate" (click)="addRate()">{{'valuationEventCurrencies.addRate' | translate}}</button>
      <button kendoButton class="save" (click)="save()" [disabled]="invalid">{{'valuationEventCurrencies.save' | translate}}</button>
    </div>
  </div>

  <div *ngIf="externalRatesDialogIsOpened">
    <external-rates-dialog [fromCurrencyIsoCode]="fromCurrencyISOCode"
                           [toCurrencyIsoCode]="toCurrencyISOCode"
                           (onCloseClicked)="closeExternalRateDialogClicked()">
    </external-rates-dialog>
  </div>
</div>
